module.exports = __webpack_public_path__ + "static/media/EntDetailsScreen_elStartplaying_730728.3c945f46.jpg";